import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getPeymankar({ page = "page=1", term = "" }) {
  const data = await getFetch(`/Peymankar?term=${term}&${page}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storePeymankar(form) {
  if (form.get('name') === '') {
    return {
      status: 'error',
      message: 'عنوان الزامی است!',
    }
  }

  const res = await postFetchWithToken("/Peymankar/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'پیمانکار با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }
}
async function deletePeymankar(id) {
  const res = await postFetchWithBody(`/Peymankar/destroy`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getPeymankar, storePeymankar,deletePeymankar };
